export const transformScaleValueToString = (value) => (value.toLocaleString('en-GB', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
}));
